
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cabinet",
      function () {
        return require("private-next-pages/cabinet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cabinet"])
      });
    }
  